// flow
import React, {useEffect, useState} from 'react';
import moment from 'moment';
import { connect } from 'react-redux';
// Components
import OrderTracker from '../../common/components/OrderTracker';
import HorizontalDivider from './HorizontalDivider';
import LastOrderInfoSkeleton from './LastOrderInfoSkeleton';
// Selectors
import {
  ordersListSelector,
  gettingOrdersLoadingSelector,
} from '../../past-orders/selectors';
// Actions
import { getPastOrders } from '../../past-orders/actions';
// common
import { orderTrackerStateName } from '../../common/commonHelpers';
import './LastOrderInfo.css';

const LastOrderInfo = (props: Props) => {
  const [order, setOrder] = useState(null);
  
  useEffect(()=> {
    props.getPastOrders(1, 10);
  },[])

  useEffect(()=> {
    const orders = props.orders ?? [];
    const filteredOrders = orders.filter((orderItem) => orderItem.state === 'complete' && (orderTrackerStateName(orderItem.fulfillmentState, orderItem.deliveryState) !== 'erro' || orderTrackerStateName(orderItem.fulfillmentState, orderItem.deliveryState) !== 'canceled'));
    const firstOrder = filteredOrders.length > 0 ? filteredOrders[0] : null;

    if (
      firstOrder &&
      (!order || order.id !== firstOrder.id)
    ) {
      setOrder(firstOrder);
    }
  },[props.orders]);

    if (props.loading) return <LastOrderInfoSkeleton />;

    if (!order) return null;

    if (
      moment
        .duration(moment(moment.now()).diff(order.updatedAt))
        .asDays() > 2
    )
      return null;

    return (
      <>
        <div className="last-order-info-header">
          <HorizontalDivider
            title="Último Pedido"
            link={`/minha-conta/pedidos/${order.number}`}
          />
        </div>
        <div className="last-order-info-container">
          {order && (
            <OrderTracker order={order} loading={false} />
          )}
        </div>
      </>
    );
}

const mapStateToProps = (state, ownProps) => {
  return {
    orders: ordersListSelector(state),
    loading: gettingOrdersLoadingSelector(state),
  };
};

const mapDispatchToProps = (dispatch: Dispatch, ownProps) => {
  return {
    getPastOrders: (page: number, perPage: number) => {
      dispatch(getPastOrders(page, perPage));
    },
  };
};

const connector: Connector<{}, Props> = connect(
  mapStateToProps,
  mapDispatchToProps,
);

export default connector(LastOrderInfo);
